/* SwitchToIoTDeviceExplorerRenderer.js */

"use strict";
const Registrations = require("../../../../../RegistrationNamespaces");
//const _ = require('lodash');

class SwitchToDeviceExplorerRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("config-audit-view-gl");
        this._logger = this._model.logger;
    }

    shutdown() {
        this._model = undefined;
        this._rootElem = undefined;
        this._logger = undefined;
        return Promise.resolve();
    }

    get rootElement() {
        return this._rootElem;
    }

    get model() {
        return this._model;
    }

    get selectedRows() {
        return this._deviceEntityGrid.getSelectedRows();
    }

    render() {
        this.model._gameEditor._cabinetCmpnt.emit("ExplorerChanged");
        //this.model.closeAllEditors();
        this.model._gameEditor.openLMRBExplorer(
            Registrations.DATA_EXPLORER_IOT_DEVICE_EXPLORER_ENTITY_LMRB
        );
    }
}

module.exports = SwitchToDeviceExplorerRenderer;
